import { useEffect } from "react"

import { useTranslation } from "react-i18next"

export function useDocumentLang() {
  const { i18n } = useTranslation()

  useEffect(() => {
    const langMap: Record<string, string> = {
      en: "en",
      cy: "cy",
    }

    const lang = langMap[i18n.language] || i18n.language

    document.documentElement.lang = lang
  }, [i18n.language])
}
